var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#23292F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9769 4.5H14.6025L11.2191 7.85081C10.6275 8.43363 9.83043 8.76033 9 8.76033C8.16957 8.76033 7.37248 8.43363 6.78094 7.85081L3.39469 4.5H5.02313L7.59375 7.04419C7.96809 7.41367 8.4729 7.62084 8.99888 7.62084C9.52485 7.62084 10.0297 7.41367 10.404 7.04419L12.9769 4.5ZM5.00344 13.8167H3.375L6.78094 10.4456C7.37248 9.86281 8.16957 9.5361 9 9.53611C9.83043 9.5361 10.6275 9.86281 11.2191 10.4456L14.625 13.8161H12.9966L10.4062 11.25C10.0319 10.8805 9.5271 10.6733 9.00113 10.6733C8.47515 10.6733 7.97034 10.8805 7.596 11.25L5.00288 13.8167H5.00344Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/XRP.a73286e454e5632396f4daf192eb025d.svg";
export { ForwardRef as ReactComponent };